import { MaintenanceWindowsSideNavWebComponent } from './component/MaintenanceWindowsSideNavWebComponent';
import { WEB_COMPONENT_MAINTENANCE_WINDOWS_SIDE_NAV } from '../../webcomponents.constants';

export { MaintenanceWindowsSideNavWebComponent };

window.customElements.define(WEB_COMPONENT_MAINTENANCE_WINDOWS_SIDE_NAV, MaintenanceWindowsSideNavWebComponent);
